import React, { useState, useEffect } from 'react';
import * as turf from '@turf/turf';

// Import CSS & assets
import ico_close from '../../../../assets/ico/ico_close.svg';
import ico_map_layers from '../../../../assets/ico/ico_map_layers.svg';



const ZoneUrba2 = ({ capacity, zoneUrba2_data, zoneUrba2_index, libelle_update, description_update, label_update, index_update, geojson_update, mapShow_change, zoneUrba2_mapShow, zoneUrba2_Delete }) => {

    const [isActions, setIsActions] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isJsonOpen, setIsJsonOpen] = useState(false);
    const [isJsonValid, setIsJsonValid] = useState({ state: "" });

    useEffect(() => {
        if (isJsonOpen === true) {
            // if (zoneUrba2_data?.geometry?.type === "MultiPolygon") {
            if (zoneUrba2_data?.geometry?.type === "FeatureCollection") {
                try {
                    var geojson_string = JSON.stringify(zoneUrba2_data?.geometry);
                    document.getElementById("zoneUrba2_json_import").value = geojson_string;
                } catch (error) {
                    console.log(error);
                }
            }
        }
    }, [isJsonOpen])
    const handleJsonChange = (e) => {
        setIsJsonValid({ ...isJsonValid, state: "loading" });
        checkJsonValidity(e.target.value);
    }
    const checkJsonValidity = (rule) => {
        console.log("parsing...", rule);
        if (rule === "") {
            setIsJsonValid({ ...isJsonValid, state: "null" });
        }
        else {
            try {
                var rule_parsed = JSON.parse(rule);
                console.log("rule_parsed", rule_parsed);
                // var rule_parsed_type = rule_parsed?.type;
                // var rule_parsed_coords = rule_parsed?.coordinates;
                // // Check
                // if (rule_parsed_type === "MultiPolygon" && rule_parsed_coords[0].length > 0 && rule_parsed_coords[0][0].length > 3 && rule_parsed_coords[0][0][0].length === 2) {
                //     setIsJsonValid({ ...isJsonValid, state: "valid" });
                // }
                // else {
                //     setIsJsonValid({ ...isJsonValid, state: "invalid" });
                // }
                var rule_parsed_type = rule_parsed?.type;
                var rule_parsed_features = rule_parsed?.features;
                // Check
                if (rule_parsed_type === "FeatureCollection" && rule_parsed_features && Array.isArray(rule_parsed_features) && rule_parsed_features.length > 0) {
                    setIsJsonValid({ ...isJsonValid, state: "valid" });
                }
                else {
                    setIsJsonValid({ ...isJsonValid, state: "invalid" });
                }
            } catch (e) {
                console.log("Error parsing JSON", e);
                setIsJsonValid({ ...isJsonValid, state: "invalid" });
            }
        }
    }

    const handleClickDelete = () => {
        setIsActions(false);
        setIsDelete(true);
    }

    const handleLibelleChange = (newLibelle) => {
        if (zoneUrba2_data?.properties?.libelle !== newLibelle) {
            libelle_update(zoneUrba2_data?.properties?.id, newLibelle);
        }
    }
    const handleLibelongChange = (newLibelle) => {
        if (zoneUrba2_data?.properties?.libelong !== newLibelle) {
            description_update(zoneUrba2_data?.properties?.id, newLibelle);
        }
    }
    const handleLabelChange = (newLibelle) => {
        if (zoneUrba2_data?.properties?.label !== newLibelle) {
            label_update(zoneUrba2_data?.properties?.id, newLibelle);
        }
    }
    const handleIndexChange = (newIndex) => {
        if (newIndex >= 0 && newIndex !== zoneUrba2_index) {
            index_update(zoneUrba2_data?.properties?.id, newIndex);
        }
    }
    const handleGeoJsonChange = () => {
        setIsJsonValid({ ...isJsonValid, state: "saving" });
        var newGeoJson_string = document.getElementById("zoneUrba2_json_import").value;
        var newGeoJson = JSON.parse(newGeoJson_string);
        setTimeout(() => {
            // Get intersections with zoneUrba
            var newGeoJsonIntersections = geoJsonGetIntersection(newGeoJson);
            // Save
            geojson_update(zoneUrba2_data?.properties?.id, newGeoJson, newGeoJsonIntersections);
            // Close & Reset GeoJson modal
            document.getElementById("zoneUrba2_json_import").value = "";
            setIsJsonValid({ ...isJsonValid, state: "null" });
            setIsJsonOpen(false);
        }, 500);
    }
    const geoJsonGetIntersection = (zu2) => {
        console.log("CALCULATE INTERSECTIONS...");
        var intersection_list = [];
        // Get each ZoneUrba2 feature
        if (zu2?.type === "FeatureCollection" && zu2?.features.length > 0) {
            for (var i = 0; i < zu2?.features.length; i++) {
                var poly_zu2 = null;
                var feature = zu2?.features[i];
                if (feature?.geometry?.type === "MultiPolygon" || feature?.geometry?.type === "Polygon") {
                    console.log("_______________________________");
                    console.log((i + 1) + " / " + zu2.features.length);
                    poly_zu2 = feature;
                    // Get all ZoneUrba
                    capacity.rules.gpu_data.zoneUrba_all.forEach((zu) => {
                        if (!intersection_list.includes(zu?.properties?.id)) {
                            if (zu?.geometry?.type === "MultiPolygon") {
                                // console.log(zu.properties.id)
                                for (var j = 0; j < zu.geometry.coordinates[0].length; j++) {
                                    var poly_zu = turf.polygon([zu.geometry.coordinates[0][j]]);
                                    // Test intersection
                                    var intersection = turf.intersect(poly_zu2, poly_zu);
                                    // console.log("intersection", intersection);
                                    if (intersection) {
                                        console.log("MATCH : " + (i + 1) + " & " + zu.properties.id + "(" + j + ")");
                                        var area = turf.area(intersection);
                                        console.log("area " + area);
                                        if (area > 1) {
                                            intersection_list.push(zu?.properties?.id);
                                            break;
                                        }
                                    }
                                }
                            }
                            else if (zu?.geometry?.type === "Polygon") {
                                // console.log(zu.properties.id)
                                var poly_zu = { ...zu, type: "Feature" }
                                // Test intersection
                                var intersection = turf.intersect(poly_zu2, poly_zu);
                                // console.log("intersection", intersection);
                                if (intersection) {
                                    console.log("MATCH : " + (i + 1) + " & " + zu.properties.id);
                                    var area = turf.area(intersection);
                                    console.log("area " + area);
                                    if (area > 1) {
                                        intersection_list.push(zu?.properties?.id);
                                    }
                                }
                            }
                        }
                    });
                }
            }
        }
        return intersection_list
    }



    return (
        <div className="app__ruleset_zoneUrba2_container_main">
            {capacity?.isModel === true ?
                <>
                    <div className="app__ruleset_zoneUrba2_container_left">
                        <div className="app__ruleset_zoneUrba2_label_input_container">
                            <input className="app__ruleset_zoneUrba2_index_input" style={{ width: "30px" }} type="number" name="index" min="0" placeholder="#" onChange={(e) => { }} onBlur={(e) => { handleIndexChange(parseInt(e.target.value)) }} defaultValue={zoneUrba2_index}></input>
                            <input className="app__ruleset_zoneUrba2_label_input" type="text" name="title" placeholder="Libellé de la zone" onChange={(e) => { }} onBlur={(e) => { handleLibelleChange(e.target.value) }} defaultValue={zoneUrba2_data?.properties?.libelle}></input>
                            <input className="app__ruleset_zoneUrba2_label_input" style={{ width: "60px" }} type="text" name="title" placeholder="Label" onChange={(e) => { }} onBlur={(e) => { handleLabelChange(e.target.value) }} defaultValue={zoneUrba2_data?.properties?.label || ""}></input>
                        </div>
                        <input className="app__ruleset_zoneUrba2_description_input" type="text" name="title" placeholder="Description de la zone" onChange={(e) => { }} onBlur={(e) => { handleLibelongChange(e.target.value) }} defaultValue={zoneUrba2_data?.properties?.libelong}></input>
                    </div>
                    <div className="app__ruleset_zoneUrba2_container_right">
                        <div className="app__land_data_button" style={{ width: "60px" }} onClick={() => { setIsJsonOpen(true) }}>GeoJson</div>
                        <div className="app__sectiondata_widget_layer">
                            <img src={ico_map_layers} alt="ico_map_layers" />
                            <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id={"sectiondata_switch_highlightedRule_" + zoneUrba2_data?.properties?.id} checked={zoneUrba2_mapShow.includes(zoneUrba2_data?.properties?.id) ? true : false} onChange={() => { mapShow_change(zoneUrba2_data?.properties?.id) }} /><label className={`app__map_layer_checkbox_label ${zoneUrba2_data?.geometry?.type === "FeatureCollection" ? "" : "app__ruleset_zoneUrba2_mapcheckbox_hidden"}`} htmlFor={"sectiondata_switch_highlightedRule_" + zoneUrba2_data?.properties?.id}>Toggle</label></div>
                        </div>
                        <div className="app__ruleset_title_button_container" onClick={() => { setIsDelete(true) }}>
                            <img src={ico_close} alt="dots" />
                        </div>
                    </div>
                </>
                :
                <>
                    <div className="app__ruleset_zoneUrba2_container_left">
                        <div className="app__ruleset_document_title_small" style={{ marginBottom: "4px" }}>{zoneUrba2_data?.properties?.libelle || "Libellé de la zone"}{zoneUrba2_data?.properties?.value ? " : " + zoneUrba2_data.properties.value : ""}</div>
                        {/* <input className="app__ruleset_zoneUrba2_label_input" type="text" name="title" placeholder="Libellé de la zone" onChange={(e) => { }} onBlur={(e) => { handleLibelleChange(e.target.value) }} defaultValue={zoneUrba2_data?.properties?.libelle}></input> */}
                        <div className="app__ruleset_document_description_small">{zoneUrba2_data?.properties?.libelong || "Description de la zone"}</div>
                        {/* <input className="app__ruleset_zoneUrba2_description_input" type="text" name="title" placeholder="Description de la zone" onChange={(e) => { }} onBlur={(e) => { handleLibelongChange(e.target.value) }} defaultValue={zoneUrba2_data?.properties?.libelong}></input> */}
                    </div>
                </>
            }
            {isActions &&
                <div className="app__ruleset_document_actions_container scale-up-topright" onMouseLeave={() => { setIsActions(false) }}>
                    <div className="app__landsvalidation_popup_button_second" onClick={handleClickDelete}>Supprimer ce titre</div>
                </div>
            }
            {isDelete &&
                <div className="app__ruleset_title_actions_container">
                    <div className="app__bound_type_modify_title_big" style={{ color: "#062134", fontWeight: "600", margin: "0px" }}>Supprimer cette zone ?</div>
                    <div className="app__ruleset_document_deletion_container" style={{ width: "300px" }}>
                        <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { zoneUrba2_Delete(zoneUrba2_data?.properties?.id) }}>Supprimer</div>
                    </div>
                </div>
            }
            {isJsonOpen &&
                <div className="app__exportation_modal_background">
                    <div className="app__exportation_modal_container scale-up-center">
                        <div className="app__exportation_modal_close" onClick={() => { setIsJsonOpen(false) }}><img src={ico_close} alt="close" /></div>
                        <div className="app__exportation_modal_title">{zoneUrba2_data?.properties?.libelle || "Zone Urba"}</div>
                        <div className="app__sectiondata_widget_spacer_15"></div>
                        <textarea id="zoneUrba2_json_import" className="app__rulecatalog_textarea" style={{ height: '200px' }} name="textarea" onChange={handleJsonChange} placeholder='Copiez le GeoJson de la zone ici.&#10;Exemple :&#10;{&#13;&#160;&#160;"type": "MultiPolygon",&#13;&#160;&#160;"coordinates": [&#13;&#160;&#160;&#160;&#160;[&#13;&#160;&#160;&#160;&#160;&#160;&#160;<liste de polygones>&#13;&#160;&#160;&#160;&#160;]&#13;&#160;&#160;]&#10;}'></textarea>
                        <div className="app__rulecatalog_buttons_container">
                            <div id="zoneUrba2_json_button" className={`app__rulecatalog_button ${isJsonValid?.state === "valid" ? "" : "app__rulecatalog_button_hidden"}`} onClick={handleGeoJsonChange}>{isJsonValid?.state === "valid" ? "Enregistrer le GeoJson" : isJsonValid?.state === "loading" ? "Analyse du GeoJson" : isJsonValid?.state === "saving" ? "Traitement..." : isJsonValid?.state === "invalid" ? "GeoJson invalide" : "Copiez un GeoJson pour continuer"}</div>
                        </div>
                    </div>
                </div>
            }
        </div>
    );
};

export default ZoneUrba2;